export default __webpack_public_path__ + "static/media/logo.bb0b75a5.svg";